import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { VideosPageVideo } from 'app/shared/typings';
import { Box, Typography } from 'app/shared/components/atoms';
import { BasePageBox } from 'app/shared/components/molecules';
import { VideoThumbnailsGrid } from 'app/fan/components/molecules';

interface ArtistVideosProps {
  videos?: VideosPageVideo[];
  videosLoading: boolean;
  artistTitle?: string;
}

const ArtistVideos: React.FC<React.PropsWithChildren<ArtistVideosProps>> = ({
  videos = [],
  videosLoading,
  artistTitle,
}) => {
  const intl = useIntl();
  const { colors } = useCurrentTheme();

  return (
    <Box
      pt={10}
      pb={20}
      data-qaid="artist-videos-section-main-container"
      backgroundColor={colors.primary.white.lighter}
    >
      <BasePageBox>
        <Typography
          as="h2"
          fontFamily="title"
          fontSize="fontSize600"
          lineHeight="100%"
          data-qaid="artist-videos-section-header"
        >
          {intl.formatMessage({
            id: 'artist.videos',
          })}
        </Typography>
        {!videosLoading && !!artistTitle && videos.length === 0 && (
          <Typography
            mt={5}
            data-qaid="artist-videos-section-body"
            display="block"
          >
            {intl.formatMessage({ id: 'artist.noVideos' }, { artistTitle })}
          </Typography>
        )}
      </BasePageBox>
      <VideoThumbnailsGrid
        videos={videos}
        videosLoading={videosLoading}
        data-qaid="artist-videos-grid"
      />
    </Box>
  );
};

export default ArtistVideos;
